// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__2Wo-e","form":"styles_form__2uSrK"};